
if ($('.optical-random-id').length) {
    $('#AddToCart').attr('data-line-property-id', Math.floor(Math.random() * 9999999 + 1));
}

$(document).on('change', '#frameCase', function () {
    if ($(this).is(':checked')) {
        $('#AddToCart').attr('data-include-frame-case', true);
        $('#buyItNowBtn').attr('data-include-frame-case', true);
    } else {
        $('#AddToCart').attr('data-include-frame-case', false);
        $('#buyItNowBtn').attr('data-include-frame-case', false);
    }
    //console.log('frameCase changed');
});



